import {axios} from "./config"
export class Notification extends axios{
   axios;
   token;
   constructor(){
   super();
   this.axios=this.axiosConfig();
 }
  async getAllNotification(data){
           
                try{
                let result=await this.axios({
                method:"post",
                url:"notification/getAllNotification",
                data
                
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
                  async getLimitNotification(){
           
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"notification/getLimitNotification",
                    
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
async seeAllNotification(type){
           
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"notification/seeAllNotification",
                    data:{type}
                    
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
                  
   
        
}